<template>
	<div class="notification-b">
		<p></p>
		<span></span>
	</div>
</template>

<script>
	export default{
		props: ['nbc', 'nbm'],
		mounted(){
			this.$el.getElementsByTagName('span')[0].style.background = this.nbc;
			this.$el.getElementsByTagName('p')[0].textContent = this.nbm;
		}
	}
</script>


// WEBPACK FOOTER //
// CartNotification.vue?499b74d6